import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import Uploader from 'modules/common/components/Uploader';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import moment from 'moment';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import * as c from '../constant';
import * as actions from '../actions';

function ManualPaymentPostingModal({
  id,
  data,
  postingPayment,
  paymentPosting,
  getItem,
}) {
  const [formData, setFormData] = useState({
    manual_posting_paid_at: '',
    manual_posting_reason: '',
    manual_posting_reference_no: '',
    manual_posting_reference_url: '',
    amount: '',
  });
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    manual_posting_paid_at: 'required',
    manual_posting_reason: 'required',
    manual_posting_reference_no: 'required',
    manual_posting_reference_url: 'required',
    amount: 'required',
  });

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      manual_posting_reference_no: _.get(
        formData,
        'manual_posting_reference_no'
      )
        ? _.get(formData, 'manual_posting_reference_no').toUpperCase()
        : '',
    };

    paymentPosting(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangeDate = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.target.value : '',
    });
  };

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangePhoto = key => url => {
    setFormData({
      ...formData,
      [key]: url.cdnUrl,
    });
  };

  const applicationDate =
    moment(_.get(data, 'attributes.processing_at')).format('MM/DD/YYYY') || '';

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Upload Receipt{' '}
              {validateForm.renderMessage('manual_posting_reference_url')}
            </label>
            <div className="col-12">
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(
                    _.get(formData, 'manual_posting_reference_url') || ''
                  )
                    ? _.get(formData, 'manual_posting_reference_url') ||
                      ImagePlaceholder
                    : _.get(formData, 'manual_posting_reference_url.cdnUrl') ||
                      ImagePlaceholder
                }
                alt=""
              />
            </div>
            <div className="col-12 form-group">
              <Uploader
                className="btn btn-block btn-primary cms-bg-color-primary cms-outline-primary     "
                customLoading={<i className="fas fa-spinner fa-spin" />}
                icon={<i className="far fa-image" />}
                label="Upload Photo"
                onChange={onChangePhoto('manual_posting_reference_url')}
                crop="free"
                imagesOnly
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Paid at {validateForm.renderMessage('manual_posting_paid_at')}
            </label>
            <DateInputPicker
              className="form-control"
              minDate={new Date(applicationDate)}
              maxDate={new Date()}
              onChange={onChangeDate('manual_posting_paid_at')}
              value={_.get(formData, 'manual_posting_paid_at') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Reference Number{' '}
              {validateForm.renderMessage('manual_posting_reference_no')}
            </label>
            <input
              className="form-control"
              type="text"
              name="manual_posting_reference_no"
              onChange={onChange}
              value={_.get(formData, 'manual_posting_reference_no') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  amount: floatValue || '',
                });
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              prefix="₱ "
              value={_.get(formData, 'amount', '') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Reason {validateForm.renderMessage('manual_posting_reason')}
            </label>
            <input
              className="form-control"
              type="text"
              name="manual_posting_reason"
              onChange={onChange}
              value={_.get(formData, 'manual_posting_reason')}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            disabled={postingPayment || !validateForm.response.is_passed}
          >
            <span className="font-weight-bold">
              {/* eslint-disable */}
              {postingPayment ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ManualPaymentPostingModal.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  paymentPosting: PropTypes.instanceOf(Function).isRequired,
  postingPayment: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  postingPayment: api.loading.indexOf(c.PAYMENT_POSTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ManualPaymentPostingModal);
